/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsEditAliases {
  ACTION_DELETE_WOUND = 'action-delete-wound',
  ACTION_END_TREATMENT = 'action-end-treatment',
  ACTION_NEW_WOUND = 'action-new-wound',
  ACTION_RELEASE_WOUND = 'action-release-wound',
  ACTION_UNDO_END_TREATMENT = 'action-undo-end-treatment',
  AUTOCOMPLETE_CLINIC = 'autocomplete-clinic',
  AUTOCOMPLETE_COMPLEMENT = 'autocomplete-complement',
  AUTOCOMPLETE_END_TREATMENT = 'autocomplete-end-treatment',
  AUTOCOMPLETE_SECTOR = 'autocomplete-sector',
  AUTOCOMPLETE_WOUND_CLASSIFCATION = 'autocomplete-wound-classifcation',
  AUTOCOMPLETE_WOUND_LOCATION = 'autocomplete-wound-location',
  AUTOCOMPLETE_WOUND_SHAPE = 'autocomplete-wound-shape',
  AUTOCOMPLETE_WOUND_TYPE = 'autocomplete-wound-type',
  CHECKBOX_MEDICINE_ALLERGY = 'checkbox-medicine-allergy',
  CHECKBOX_PREVIOUS_HISTORY = 'checkbox-previous-history',
  CHECKBOX_REPORTED_PAIN = 'checkbox-reported-pain',
  CHECKBOX_UNKNOWN_START = 'checkbox-unknown-start',
  CONTEXTUAL_BAR_BODY = 'contextual-bar-body',
  FETCH_CLINIC = 'fetch-clinic',
  FETCH_COMPLEMENT = 'fetch-complement',
  FETCH_END_TREATMENT = 'fetch-end-treatment',
  FETCH_SECTOR = 'fetch-sector',
  FETCH_WOUND_CLASSIFICATION = 'fetch-wound-classification',
  FETCH_WOUND_LOCATION = 'fetch-wound-location',
  FETCH_WOUND_SHAPE = 'fetch-wound-shape',
  FETCH_WOUND_TYPE = 'fetch-wound-type',
  FIELD_ADMITTED_INJURY = 'field-admitted-injury',
  FIELD_ALLERGIES = 'field-allergies',
  FIELD_CLINIC = 'field-clinic',
  FIELD_COMPLEMENT = 'field-complement',
  FIELD_MAIN_DIAGNOSIS = 'field-main-diagnosis',
  FIELD_MEDICINE_ALLERGY = 'field-medicine-allergy',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PAIN_SITE = 'field-pain-site',
  FIELD_PREVIOUS_HISTORY = 'field-previous-history',
  FIELD_REASON_END_TREATMENT = 'field-reason-end-treatment',
  FIELD_RELEASE_DATE = 'field-releaseDate',
  FIELD_RELEASE_USER = 'field-release-user',
  FIELD_REPORTED_PAIN = 'field-reported-pain',
  FIELD_SECTOR = 'field-sector',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNKNOWN_START = 'field-unknown-start',
  FIELD_WHAT_USED = 'field-what-used',
  FIELD_WHO_TREATED = 'field-who-treated',
  FIELD_WOUND_CLASSIFICATION = 'field-wound-classification',
  FIELD_WOUND_DAY = 'field-wound-day',
  FIELD_WOUND_LOCATION = 'field-wound-location',
  FIELD_WOUND_MONTH = 'field-wound-month',
  FIELD_WOUND_SHAPE = 'field-wound-shape',
  FIELD_WOUND_TYPE = 'field-wound-type',
  FIELD_WOUND_YEAR = 'field-wound-year',
  FORM_FOUR = 'form-four',
  FORM_ONE = 'form-one',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_ALLERGIES = 'input-allergies',
  INPUT_MAIN_DIAGNOSIS = 'input-main-diagnosis',
  INPUT_OBSERVATION = 'input-observation',
  INPUT_PAIN_SITE = 'input-pain-site',
  INPUT_RELEASE_DATE = 'input-release-date',
  INPUT_RELEASE_USER = 'input-release-user',
  INPUT_START_DATE = 'input-start-date',
  INPUT_WHAT_USED = 'input-what-used',
  INPUT_WHO_TREATED = 'input-who-treated',
  INPUT_WOUND_DAY = 'input-wound-day',
  INPUT_WOUND_MONTH = 'input-wound-month',
  INPUT_WOUND_YEAR = 'input-wound-year',
  LAYOUT_WOUNDS_EDIT = 'layout-wounds-edit',
  MAPPER_CLINIC = 'mapper-clinic',
  MAPPER_COMPLEMENT = 'mapper-complement',
  MAPPER_END_TREATMENT = 'mapper-end-treatment',
  MAPPER_SECTOR = 'mapper-sector',
  MAPPER_WOUND_CLASSIFICATION = 'mapper-wound-classification',
  MAPPER_WOUND_LOCATION = 'mapper-wound-location',
  MAPPER_WOUND_SHAPE = 'mapper-wound-shape',
  MAPPER_WOUND_TYPE = 'mapper-wound-type',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_GROUP_ADMITTED_INJURY = 'radio-group-admitted-injury',
  TEXT_CLINIC = 'text-clinic',
  TEXT_COMPLEMENT = 'text-complement',
  TEXT_END_TREATMENT = 'text-end-treatment',
  TEXT_SECTOR = 'text-sector',
  TEXT_WOUND_CLASSIFICATION = 'text-wound-classification',
  TEXT_WOUND_LOCATION = 'text-wound-location',
  TEXT_WOUND_SHAPE = 'text-wound-shape',
  TEXT_WOUND_TYPE = 'text-wound-type',
  WIZARD = 'wizard',
  WIZARD_STEP_FOUR = 'wizard-step-four',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { WoundsEditAliases };
